/* UI texts in 3 languages. **text** renders as <strong>.
   Arrays (flow, capabilities, equipment, cameras, advantages) follow the same order
   as the data arrays in home.jsx. */

const T = {
    ru: {
        langName: "Русский",
        nav: {
            about: "О компании",
            capabilities: "Возможности",
            equipment: "Оборудование",
            cameras: "Камеры",
            contact: "Контакты",
        },
        cta: "Оставить заявку",
        menu: "Меню",
        home: "На главную",

        hero: {
            slogan: "Видим каждую единицу техники",
            sloganHl: "в любой точке мира",
            lead: "ALL SYSTEMS — GPS/ГЛОНАСС мониторинг транспорта, контроль расхода топлива и видеонаблюдение на платформе Wialon с покрытием по всему миру. Наша база — Нукус: работаем с выездом на место по Каракалпакстану и Хорезму.",
            ctaPrimary: "Заказать тестовый монтаж",
            ctaSecondary: "Что умеет система",
            more: "Подробнее",
            stats: ["экономии на автопарке", "онлайн-контроль техники", "страны, где работает Wialon"],
            panel: "ALL SYSTEMS · обмен данными 24/7",
            nodes: {
                client: "ТЕЛЕФОН КЛИЕНТА / ПК",
                server: "СЕРВЕР WIALON",
                vehicle: "ТРАНСПОРТ",
                gps: "GPS / ГЛОНАСС",
                satellite: "СПУТНИК",
            },
            svgLabel: "Схема связи: телефон клиента / ПК — сервер Wialon — транспорт, спутник над транспортом",
        },
        partners: "Работаем на оборудовании и ПО",

        about: {
            eyebrow: "О компании",
            title: "ALL SYSTEMS — локальная экспертиза и проверенные технологии",
            lead: "ALL SYSTEMS — компания, специализирующаяся на спутниковом мониторинге транспорта и видеонаблюдении. Платформа Wialon, на которой мы работаем, охватывает 132 страны, поэтому транспорт клиента можно контролировать в любой точке мира, где бы он ни находился.",
            p1: "Наша база — в Нукусе: здесь выездная бригада, склад оборудования и локальная поддержка, а работаем мы по всему Каракалпакстану и Хорезму. Берём на себя всё, что происходит на месте: выезд специалиста, монтаж оборудования, настройку отчётов и сопровождение клиента — на проверенной платформе **Wialon Local** и сертифицированном оборудовании Teltonika, Omnicomm и «Эскорт».",
            p2: "Такой формат даёт клиентам две вещи одновременно: глобальное покрытие платформы мирового уровня — и скорость локальной команды именно в вашем регионе.",
            how: "Как это работает",
        },
        flow: [
            ["Спутник", "Бортовой терминал принимает сигнал GPS/ГЛОНАСС и вычисляет координаты транспортного средства."],
            ["Терминал на борту", "Teltonika FMB920 / FMB125 собирает данные: местоположение, топливо, датчики, CAN-шину."],
            ["Сервер Wialon", "Данные передаются по GSM/GPRS на сервер с программным обеспечением Wialon Local."],
            ["Ваш личный кабинет", "Диспетчер и руководитель получают отчёты и карту в реальном времени с любого устройства."],
        ],

        cap: {
            eyebrow: "Возможности системы",
            title: "Полный контроль над автопарком — по каждому параметру",
            text: "Готовые решения для оптимизации затрат и повышения эффективности использования транспорта, построенные на платформе Wialon.",
        },
        capabilities: [
            ["Местоположение", ["Выявление несанкционированных рейсов", "Контроль разрешённых маршрутов", "Локатор без входа в систему"]],
            ["Расход топлива", ["Учёт заправок и сливов", "Выявление перерасхода", "Фактические нормы расхода"]],
            ["Пробег", ["Автооповещение о ТО", "Расчёт с заказчиком по километражу", "Исключение махинаций со спидометром"]],
            ["Геозоны", ["Контроль маршрутного задания", "Создание точек интереса (POI)", "Несанкционированный въезд/выезд"]],
            ["Скоростной режим", ["Отслеживание параметров движения", "Безопасность грузопассажирских перевозок"]],
            ["Работа водителей", ["Выявление простоев и нарушений графика", "Идентификация водителя по ключу", "ECO driving — качество вождения"]],
            ["Доп. оборудование", ["Учёт работы генераторов, кранов, компрессоров", "Удалённая блокировка запуска", "Мониторинг температуры в рефрижераторах"]],
            ["Отчёты и аналитика", ["«Быстрый отчёт» за период", "Email-уведомления о нарушениях", "Собственные шаблоны отчётов"]],
        ],

        eq: {
            eyebrow: "Оборудование",
            title: "Сертифицированные GPS-трекеры и датчики топлива",
            text: "Поставляем и устанавливаем сертифицированное оборудование — с гарантией и сервисной поддержкой на месте.",
            flyer: "Флаер PDF",
            note: "Подберём оборудование практически для любого типа техники и производителя — включая китайские марки, такие как **Sinotruck** и другие. Если нужна установка под конкретную марку — уточните у менеджера ALL SYSTEMS.",
        },
        equipment: [
            ["Teltonika FMB920", "Устанавливается на ТС с пластиковой приборной панелью, без подключения датчика уровня топлива."],
            ["Teltonika FMB125", "Устанавливается на любое ТС, с подключением до 5 датчиков уровня топлива."],
            ["Эскорт TD 150", "Датчик уровня топлива, подключаемый к терминалу системы мониторинга транспорта."],
            ["Эскорт TD BLE", "Беспроводной датчик уровня топлива, подключаемый к терминалу системы мониторинга транспорта по Bluetooth."],
        ],

        cam: {
            eyebrow: "Видеонаблюдение",
            title: "Камеры на транспорт и любые объекты",
            text: "Кроме GPS-мониторинга устанавливаем видеорегистраторы и камеры **HOWEN** для транспорта и IP-камеры **Hikvision** и **Dahua** — на автомобили, склады, офисы и любые другие объекты.",
            note: "Устанавливаем камеры **Hikvision** и **Dahua** не только на здания и территории, но и на сам транспорт — в паре с GPS-мониторингом это даёт полную картину: где находится техника и что происходит вокруг неё.",
        },
        cameras: [
            ["Hero-C60S0V29", "Мини-камера для салона: следит за обстановкой в кабине, легко подключается к видеорегистратору и крепится на 3М-скотч."],
            ["PTZ AHD-камера", "Поворотная AHD-камера для уличного наблюдения: обзор 360°, чёткая картинка даже почти в темноте, управляется удалённо и не боится дождя и ударов."],
            ["Hero-C60S0V42", "Компактная AHD-камера с двумя объективами для транспорта: чёткая картинка днём и ночью, встроенный микрофон и лёгкий монтаж на 3М-скотч."],
            ["Hikvision — купольная камера", "Для помещений и территорий: чёткое изображение днём и ночью, антивандальный корпус."],
            ["Hikvision — уличная цилиндрическая камера", "Корпус IP67, ИК-подсветка до 30 м — для периметра, стоянок и въездных групп."],
            ["Hikvision — поворотная PTZ-камера", "Удалённое управление углом обзора и зумом — для больших территорий и объектов под охраной."],
            ["Dahua — уличная камера", "Влаго- и пылезащищённый корпус (IP67), ИК-подсветка до 30 м — для складов, стоянок и периметра объекта."],
            ["Dahua — купольная камера", "Компактный антивандальный корпус для офисов, магазинов и помещений — почти незаметна на потолке."],
            ["Dahua — камера с ИИ-детекцией", "Распознаёт людей и транспорт в кадре, отправляет уведомления о тревожных событиях в реальном времени."],
        ],

        region: {
            eyebrow: "Зона покрытия",
            title: "Мониторинг — по всему миру, сервис — рядом с вами",
            text: "Платформа Wialon позволяет отслеживать транспорт в любой стране. А выездная бригада ALL SYSTEMS базируется в Нукусе и оперативно закрывает монтаж, диагностику и ремонт оборудования на месте — по всему Каракалпакстану и Хорезму.",
            chips: ["Нукус", "Каракалпакстан", "Хорезм"],
            city: "НУКУС",
            globe: "WIALON · 132 СТРАНЫ",
            svgLabel: "Глобус: покрытие Wialon по всему миру, база ALL SYSTEMS — Нукус",
        },

        adv: {
            eyebrow: "Почему ALL SYSTEMS",
            title: "Проверенные технологии плюс присутствие в регионе",
        },
        advantages: [
            ["Опыт в спутниковом мониторинге", "Работаем по проверенным стандартам, на сертифицированном оборудовании и надёжной платформе Wialon."],
            ["Только проверенное оборудование", "Teltonika, Omnicomm и «Эскорт» — с реальными гарантийными обязательствами и складским наличием."],
            ["Wialon Local — ПО №1 в мире", "Более 3 500 000 подключённых объектов, доля рынка СНГ — 42%, использование в 132 странах."],
            ["Локальная выездная бригада", "Монтаж, диагностика и ремонт без ожидания специалистов из Ташкента — база в Нукусе, выезд по Каракалпакстану и Хорезму."],
            ["Обучение и поддержка", "Профессиональные консультации и техническая поддержка без ограничений по времени и количеству обращений."],
            ["Комплексный подход", "От постановки задачи и подбора решения до монтажа, запуска системы и последующего обслуживания клиента."],
        ],

        contact: {
            eyebrow: "Связаться с ALL SYSTEMS",
            title: "Запросите тестовую установку для вашего автопарка",
            text: "При автопарке от 20 единиц — бесплатное оснащение нескольких транспортных средств тестовым образцом.",
            company: "Название компании",
            companyPh: "ООО «Пример»",
            name: "Ваше имя*",
            namePh: "Имя Фамилия",
            phone: "Телефон*",
            email: "E-mail",
            service: "Тип услуги",
            services: { gps: "GPS-мониторинг", cameras: "Камеры видеонаблюдения" },
            vehicles: "Количество ТС",
            vehiclesPh: "напр. 12",
            install: "Тип установки",
            installs: { car: "Автомобиль", object: "Помещение / объект" },
            message: "Сообщение",
            messagePh: "Расскажите о вашем автопарке (помещении) и задачах",
            send: "Отправить заявку",
            sending: "Отправка...",
            consent: "Отправляя форму, вы соглашаетесь на обработку контактных данных менеджером ALL SYSTEMS.",
            successTitle: "Заявка принята",
            successText: "Менеджер ALL SYSTEMS свяжется с вами в ближайшее рабочее время.",
            again: "Отправить ещё одну",
            error: "Не удалось отправить заявку. Попробуйте ещё раз или позвоните нам:",
            phoneTitle: "Телефон",
            emailTitle: "E-mail",
            address: "Адрес",
            addressValue: "г. Нукус",
            hours: "Режим работы",
            days: [["Пн–Пт", "09:00–18:00"], ["Сб", "09:00–12:30"], ["Обед", "12:30–14:30"]],
            sunday: "Вс",
            dayOff: "Выходной",
        },

        footer: {
            about: "GPS-мониторинг транспорта, контроль расхода топлива и видеонаблюдение. База в Нукусе, работаем по Каракалпакстану и Хорезму.",
            company: "Компания",
            services: "Услуги",
            contacts: "Контакты",
            why: "Почему мы",
            coverage: "Зона покрытия",
            popular: "Популярные услуги",
            copy: "ООО «ALL SYSTEMS». Спутниковый мониторинг транспорта и видеонаблюдение.",
        },
    },

    uz: {
        langName: "O‘zbekcha",
        nav: {
            about: "Kompaniya haqida",
            capabilities: "Imkoniyatlar",
            equipment: "Uskunalar",
            cameras: "Kameralar",
            contact: "Aloqa",
        },
        cta: "Ariza qoldirish",
        menu: "Menyu",
        home: "Bosh sahifa",

        hero: {
            slogan: "Har bir texnikani ko‘rib turamiz",
            sloganHl: "dunyoning istalgan nuqtasida",
            lead: "ALL SYSTEMS — Wialon platformasida transportni GPS/GLONASS orqali monitoring qilish, yoqilg‘i sarfini nazorat qilish va videokuzatuv, butun dunyo bo‘ylab qamrov bilan. Bazamiz Nukusda: Qoraqalpog‘iston va Xorazm bo‘ylab joyiga chiqib ishlaymiz.",
            ctaPrimary: "Sinov o‘rnatishiga buyurtma",
            ctaSecondary: "Tizim imkoniyatlari",
            more: "Batafsil",
            stats: ["avtopark xarajatlarini tejash", "texnikani onlayn nazorat qilish", "Wialon ishlaydigan davlatlar"],
            panel: "ALL SYSTEMS · ma’lumot almashinuvi 24/7",
            nodes: {
                client: "TELEFON / KOMPYUTER",
                server: "WIALON SERVERI",
                vehicle: "TRANSPORT",
                gps: "GPS / GLONASS",
                satellite: "SUN’IY YO‘LDOSH",
            },
            svgLabel: "Aloqa sxemasi: mijoz telefoni / kompyuter — Wialon serveri — transport, transport ustida sun’iy yo‘ldosh",
        },
        partners: "Ishlatiladigan uskunalar va dasturlar",

        about: {
            eyebrow: "Kompaniya haqida",
            title: "ALL SYSTEMS — mahalliy tajriba va sinovdan o‘tgan texnologiyalar",
            lead: "ALL SYSTEMS — transportni sun’iy yo‘ldosh orqali monitoring qilish va videokuzatuvga ixtisoslashgan kompaniya. Biz ishlaydigan Wialon platformasi 132 ta davlatni qamrab oladi, shuning uchun mijoz transportini u qayerda bo‘lmasin, dunyoning istalgan nuqtasida nazorat qilish mumkin.",
            p1: "Bazamiz Nukusda: bu yerda chiqish brigadasi, uskunalar ombori va mahalliy qo‘llab-quvvatlash xizmati joylashgan, ishimiz esa butun Qoraqalpog‘iston va Xorazm bo‘ylab. Joyidagi barcha ishlarni o‘z zimmamizga olamiz: mutaxassis chiqishi, uskunani o‘rnatish, hisobotlarni sozlash va mijozni kuzatib borish — sinovdan o‘tgan **Wialon Local** platformasi hamda Teltonika, Omnicomm va «Eskort» sertifikatlangan uskunalarida.",
            p2: "Bunday format mijozlarga bir vaqtning o‘zida ikki narsani beradi: jahon darajasidagi platformaning global qamrovi va aynan sizning hududingizdagi mahalliy jamoaning tezkorligi.",
            how: "Bu qanday ishlaydi",
        },
        flow: [
            ["Sun’iy yo‘ldosh", "Bort terminali GPS/GLONASS signalini qabul qiladi va transport vositasining koordinatalarini hisoblaydi."],
            ["Bortdagi terminal", "Teltonika FMB920 / FMB125 ma’lumotlarni yig‘adi: joylashuv, yoqilg‘i, datchiklar, CAN-shina."],
            ["Wialon serveri", "Ma’lumotlar GSM/GPRS orqali Wialon Local dasturi o‘rnatilgan serverga uzatiladi."],
            ["Shaxsiy kabinetingiz", "Dispetcher va rahbar istalgan qurilmadan real vaqt rejimida hisobotlar va xaritani oladi."],
        ],

        cap: {
            eyebrow: "Tizim imkoniyatlari",
            title: "Avtopark ustidan to‘liq nazorat — har bir ko‘rsatkich bo‘yicha",
            text: "Wialon platformasi asosida xarajatlarni optimallashtirish va transportdan foydalanish samaradorligini oshirish uchun tayyor yechimlar.",
        },
        capabilities: [
            ["Joylashuv", ["Ruxsatsiz reyslarni aniqlash", "Ruxsat etilgan marshrutlarni nazorat qilish", "Tizimga kirmasdan lokator"]],
            ["Yoqilg‘i sarfi", ["Quyish va to‘kishlarni hisobga olish", "Ortiqcha sarfni aniqlash", "Haqiqiy sarf me’yorlari"]],
            ["Yurilgan masofa", ["Texnik xizmat haqida avtomatik eslatma", "Buyurtmachi bilan kilometr bo‘yicha hisob-kitob", "Spidometr bilan firibgarlikni istisno qilish"]],
            ["Geozonalar", ["Marshrut topshirig‘ini nazorat qilish", "Qiziqish nuqtalarini (POI) yaratish", "Ruxsatsiz kirish va chiqish"]],
            ["Tezlik rejimi", ["Harakat ko‘rsatkichlarini kuzatish", "Yuk va yo‘lovchi tashish xavfsizligi"]],
            ["Haydovchilar ishi", ["Bekor turish va jadval buzilishini aniqlash", "Haydovchini kalit orqali aniqlash", "ECO driving — haydash sifati"]],
            ["Qo‘shimcha uskunalar", ["Generator, kran va kompressorlar ishini hisobga olish", "Dvigatelni masofadan bloklash", "Refrijeratorlarda haroratni kuzatish"]],
            ["Hisobotlar va tahlil", ["Davr bo‘yicha «tezkor hisobot»", "Qoidabuzarliklar haqida email-xabarnomalar", "O‘z hisobot shablonlaringiz"]],
        ],

        eq: {
            eyebrow: "Uskunalar",
            title: "Sertifikatlangan GPS-trekerlar va yoqilg‘i datchiklari",
            text: "Sertifikatlangan uskunalarni yetkazib beramiz va o‘rnatamiz — kafolat va joyida servis xizmati bilan.",
            flyer: "PDF buklet",
            note: "Deyarli har qanday turdagi texnika va ishlab chiqaruvchi uchun uskuna tanlab beramiz — shu jumladan **Sinotruck** kabi Xitoy brendlari uchun ham. Muayyan marka uchun o‘rnatish kerak bo‘lsa, ALL SYSTEMS menejeridan so‘rang.",
        },
        equipment: [
            ["Teltonika FMB920", "Plastik asboblar paneli bo‘lgan transportga, yoqilg‘i darajasi datchigisiz o‘rnatiladi."],
            ["Teltonika FMB125", "Har qanday transportga o‘rnatiladi, 5 tagacha yoqilg‘i darajasi datchigini ulash mumkin."],
            ["Eskort TD 150", "Transport monitoringi tizimi terminaliga ulanadigan yoqilg‘i darajasi datchigi."],
            ["Eskort TD BLE", "Monitoring terminaliga Bluetooth orqali ulanadigan simsiz yoqilg‘i darajasi datchigi."],
        ],

        cam: {
            eyebrow: "Videokuzatuv",
            title: "Transport va har qanday obyekt uchun kameralar",
            text: "GPS-monitoringdan tashqari transport uchun **HOWEN** videoregistrator va kameralarini hamda **Hikvision** va **Dahua** IP-kameralarini o‘rnatamiz — avtomobillar, omborlar, ofislar va boshqa har qanday obyektlarga.",
            note: "**Hikvision** va **Dahua** kameralarini nafaqat binolar va hududlarga, balki transportning o‘ziga ham o‘rnatamiz — GPS-monitoring bilan birga bu to‘liq manzarani beradi: texnika qayerda va uning atrofida nima bo‘layapti.",
        },
        cameras: [
            ["Hero-C60S0V29", "Salon uchun mini-kamera: kabinadagi vaziyatni kuzatadi, videoregistratorga oson ulanadi va 3M-skotchga mahkamlanadi."],
            ["PTZ AHD-kamera", "Tashqi kuzatuv uchun aylanuvchi AHD-kamera: 360° ko‘rinish, deyarli qorong‘ida ham aniq tasvir, masofadan boshqariladi, yomg‘ir va zarbalardan qo‘rqmaydi."],
            ["Hero-C60S0V42", "Transport uchun ikki obyektivli ixcham AHD-kamera: kunduzi va kechasi aniq tasvir, o‘rnatilgan mikrofon va 3M-skotchga oson montaj."],
            ["Hikvision — gumbazsimon kamera", "Binolar va hududlar uchun: kunduzi va kechasi aniq tasvir, vandalizmga chidamli korpus."],
            ["Hikvision — tashqi silindrsimon kamera", "IP67 korpus, 30 m gacha IK-yoritish — perimetr, avtoturargoh va kirish joylari uchun."],
            ["Hikvision — aylanuvchi PTZ-kamera", "Ko‘rish burchagi va zumni masofadan boshqarish — katta hududlar va qo‘riqlanadigan obyektlar uchun."],
            ["Dahua — tashqi kamera", "Namlik va changdan himoyalangan korpus (IP67), 30 m gacha IK-yoritish — omborlar, avtoturargohlar va obyekt perimetri uchun."],
            ["Dahua — gumbazsimon kamera", "Ofislar, do‘konlar va xonalar uchun ixcham, vandalizmga chidamli korpus — shiftda deyarli ko‘rinmaydi."],
            ["Dahua — sun’iy intellektli kamera", "Kadrdagi odamlar va transportni taniydi, xavotirli hodisalar haqida real vaqtda xabar yuboradi."],
        ],

        region: {
            eyebrow: "Qamrov hududi",
            title: "Monitoring — butun dunyo bo‘ylab, servis — yoningizda",
            text: "Wialon platformasi istalgan davlatda transportni kuzatish imkonini beradi. ALL SYSTEMS chiqish brigadasi esa Nukusda joylashgan va butun Qoraqalpog‘iston va Xorazm bo‘ylab uskunalarni o‘rnatish, diagnostika va ta’mirlashni joyida tezkor bajaradi.",
            chips: ["Nukus", "Qoraqalpog‘iston", "Xorazm"],
            city: "NUKUS",
            globe: "WIALON · 132 DAVLAT",
            svgLabel: "Globus: Wialon butun dunyo bo‘ylab, ALL SYSTEMS bazasi — Nukus",
        },

        adv: {
            eyebrow: "Nega ALL SYSTEMS",
            title: "Sinovdan o‘tgan texnologiyalar va hududda mavjudlik",
        },
        advantages: [
            ["Sun’iy yo‘ldosh monitoringi tajribasi", "Sinovdan o‘tgan standartlar asosida, sertifikatlangan uskunalar va ishonchli Wialon platformasida ishlaymiz."],
            ["Faqat ishonchli uskunalar", "Teltonika, Omnicomm va «Eskort» — haqiqiy kafolat majburiyatlari bilan va omborda mavjud."],
            ["Wialon Local — dunyodagi №1 dastur", "3 500 000 dan ortiq ulangan obyekt, MDH bozoridagi ulushi — 42%, 132 ta davlatda qo‘llaniladi."],
            ["Mahalliy chiqish brigadasi", "Toshkentdan mutaxassis kutmasdan montaj, diagnostika va ta’mirlash — baza Nukusda, Qoraqalpog‘iston va Xorazm bo‘ylab chiqamiz."],
            ["O‘qitish va qo‘llab-quvvatlash", "Vaqt va murojaatlar soni cheklanmagan professional maslahat va texnik yordam."],
            ["Kompleks yondashuv", "Vazifani belgilash va yechim tanlashdan tortib montaj, tizimni ishga tushirish va keyingi xizmat ko‘rsatishgacha."],
        ],

        contact: {
            eyebrow: "ALL SYSTEMS bilan bog‘lanish",
            title: "Avtoparkingiz uchun sinov o‘rnatishiga ariza bering",
            text: "Avtoparkda 20 va undan ortiq transport bo‘lsa — bir nechta transportga sinov namunasini bepul o‘rnatamiz.",
            company: "Kompaniya nomi",
            companyPh: "«Namuna» MChJ",
            name: "Ismingiz*",
            namePh: "Ism Familiya",
            phone: "Telefon*",
            email: "E-mail",
            service: "Xizmat turi",
            services: { gps: "GPS-monitoring", cameras: "Videokuzatuv kameralari" },
            vehicles: "Transport soni",
            vehiclesPh: "masalan, 12",
            install: "O‘rnatish turi",
            installs: { car: "Avtomobil", object: "Bino / obyekt" },
            message: "Xabar",
            messagePh: "Avtoparkingiz (obyektingiz) va vazifalaringiz haqida yozing",
            send: "Arizani yuborish",
            sending: "Yuborilmoqda...",
            consent: "Formani yuborish orqali aloqa ma’lumotlaringiz ALL SYSTEMS menejeri tomonidan qayta ishlanishiga rozilik bildirasiz.",
            successTitle: "Ariza qabul qilindi",
            successText: "ALL SYSTEMS menejeri yaqin ish vaqtida siz bilan bog‘lanadi.",
            again: "Yana ariza yuborish",
            error: "Arizani yuborib bo‘lmadi. Qayta urinib ko‘ring yoki bizga qo‘ng‘iroq qiling:",
            phoneTitle: "Telefon",
            emailTitle: "E-mail",
            address: "Manzil",
            addressValue: "Nukus shahri",
            hours: "Ish vaqti",
            days: [["Du–Ju", "09:00–18:00"], ["Sha", "09:00–12:30"], ["Tushlik", "12:30–14:30"]],
            sunday: "Ya",
            dayOff: "Dam olish kuni",
        },

        footer: {
            about: "Transportni GPS-monitoring qilish, yoqilg‘i sarfini nazorat qilish va videokuzatuv. Bazamiz Nukusda, Qoraqalpog‘iston va Xorazm bo‘ylab ishlaymiz.",
            company: "Kompaniya",
            services: "Xizmatlar",
            contacts: "Aloqa",
            why: "Nega biz",
            coverage: "Qamrov hududi",
            popular: "Ommabop xizmatlar",
            copy: "«ALL SYSTEMS» MChJ. Transportni sun’iy yo‘ldosh orqali monitoring qilish va videokuzatuv.",
        },
    },

    en: {
        langName: "English",
        nav: {
            about: "About",
            capabilities: "Features",
            equipment: "Equipment",
            cameras: "Cameras",
            contact: "Contact",
        },
        cta: "Request a quote",
        menu: "Menu",
        home: "Home",

        hero: {
            slogan: "We see every vehicle",
            sloganHl: "anywhere in the world",
            lead: "ALL SYSTEMS provides GPS/GLONASS vehicle tracking, fuel monitoring and video surveillance on the Wialon platform with worldwide coverage. We're based in Nukus and work on site across Karakalpakstan and Khorezm.",
            ctaPrimary: "Book a test installation",
            ctaSecondary: "See what it can do",
            more: "Learn more",
            stats: ["savings on fleet costs", "online vehicle monitoring", "countries where Wialon operates"],
            panel: "ALL SYSTEMS · live data exchange 24/7",
            nodes: {
                client: "CLIENT PHONE / PC",
                server: "WIALON SERVER",
                vehicle: "VEHICLE",
                gps: "GPS / GLONASS",
                satellite: "SATELLITE",
            },
            svgLabel: "Data flow: client phone / PC — Wialon server — vehicle, with a satellite above the vehicle",
        },
        partners: "Equipment and software we use",

        about: {
            eyebrow: "About us",
            title: "ALL SYSTEMS — local expertise, proven technology",
            lead: "ALL SYSTEMS specialises in satellite vehicle tracking and video surveillance. The Wialon platform we work on covers 132 countries, so your vehicles can be monitored anywhere in the world.",
            p1: "Our base is in Nukus: our field team, equipment stock and local support are here, and we work across Karakalpakstan and Khorezm. We handle everything on site: technician visits, installation, report setup and ongoing support — on the proven **Wialon Local** platform and certified Teltonika, Omnicomm and Escort hardware.",
            p2: "This gives clients two things at once: the global reach of a world-class platform and the speed of a local team right in your region.",
            how: "How it works",
        },
        flow: [
            ["Satellite", "The on-board tracker receives GPS/GLONASS signals and calculates the vehicle's position."],
            ["On-board tracker", "Teltonika FMB920 / FMB125 collects data: location, fuel, sensors and CAN bus."],
            ["Wialon server", "Data is sent over GSM/GPRS to a server running Wialon Local."],
            ["Your dashboard", "Dispatchers and managers get reports and a live map from any device."],
        ],

        cap: {
            eyebrow: "Features",
            title: "Full control of your fleet — on every parameter",
            text: "Ready-made solutions built on Wialon to cut costs and use your vehicles more efficiently.",
        },
        capabilities: [
            ["Location", ["Detect unauthorised trips", "Control approved routes", "Share location without logging in"]],
            ["Fuel consumption", ["Track refuels and fuel drains", "Detect overconsumption", "Real consumption rates"]],
            ["Mileage", ["Automatic service reminders", "Bill clients by distance driven", "No more odometer tampering"]],
            ["Geofences", ["Monitor route assignments", "Create points of interest (POI)", "Unauthorised entry and exit alerts"]],
            ["Speed control", ["Track driving parameters", "Safer cargo and passenger transport"]],
            ["Driver behaviour", ["Detect idling and schedule violations", "Driver ID by key", "ECO driving — driving quality"]],
            ["Extra equipment", ["Track generators, cranes and compressors", "Remote engine immobilisation", "Temperature monitoring in reefers"]],
            ["Reports & analytics", ["Quick report for any period", "Email alerts on violations", "Custom report templates"]],
        ],

        eq: {
            eyebrow: "Equipment",
            title: "Certified GPS trackers and fuel sensors",
            text: "We supply and install certified hardware with a warranty and on-site service.",
            flyer: "PDF flyer",
            note: "We can fit equipment to almost any type and make of vehicle, including Chinese brands such as **Sinotruck**. Need it for a specific make? Ask an ALL SYSTEMS manager.",
        },
        equipment: [
            ["Teltonika FMB920", "For vehicles with a plastic dashboard, without a fuel level sensor."],
            ["Teltonika FMB125", "Fits any vehicle and supports up to 5 fuel level sensors."],
            ["Escort TD 150", "Fuel level sensor connected to the vehicle tracking terminal."],
            ["Escort TD BLE", "Wireless fuel level sensor that connects to the tracking terminal via Bluetooth."],
        ],

        cam: {
            eyebrow: "Video surveillance",
            title: "Cameras for vehicles and any site",
            text: "Besides GPS tracking, we install **HOWEN** dashcams and cameras for vehicles and **Hikvision** and **Dahua** IP cameras for cars, warehouses, offices and any other site.",
            note: "We install **Hikvision** and **Dahua** cameras not only on buildings and premises but on vehicles too. Combined with GPS tracking, you get the full picture: where the vehicle is and what's happening around it.",
        },
        cameras: [
            ["Hero-C60S0V29", "Mini in-cab camera: watches the cabin, connects easily to the DVR and mounts with 3M tape."],
            ["PTZ AHD camera", "Rotating AHD camera for outdoor use: 360° view, clear image even in near darkness, remote control, rain- and impact-resistant."],
            ["Hero-C60S0V42", "Compact dual-lens AHD camera for vehicles: clear image day and night, built-in microphone and easy 3M tape mounting."],
            ["Hikvision dome camera", "For indoor spaces and premises: clear image day and night, vandal-resistant housing."],
            ["Hikvision outdoor bullet camera", "IP67 housing, IR night vision up to 30 m — for perimeters, car parks and entrances."],
            ["Hikvision PTZ camera", "Remote pan, tilt and zoom — for large areas and guarded sites."],
            ["Dahua outdoor camera", "Water- and dust-proof housing (IP67), IR up to 30 m — for warehouses, car parks and site perimeters."],
            ["Dahua dome camera", "Compact vandal-resistant housing for offices, shops and rooms — barely noticeable on the ceiling."],
            ["Dahua AI detection camera", "Recognises people and vehicles in frame and sends real-time alerts about suspicious events."],
        ],

        region: {
            eyebrow: "Coverage",
            title: "Tracking worldwide, service right next to you",
            text: "Wialon lets you track vehicles in any country. The ALL SYSTEMS field team is based in Nukus and handles installation, diagnostics and repairs on site across Karakalpakstan and Khorezm.",
            chips: ["Nukus", "Karakalpakstan", "Khorezm"],
            city: "NUKUS",
            globe: "WIALON · 132 COUNTRIES",
            svgLabel: "Globe: Wialon coverage worldwide, ALL SYSTEMS base in Nukus",
        },

        adv: {
            eyebrow: "Why ALL SYSTEMS",
            title: "Proven technology plus a local presence",
        },
        advantages: [
            ["Satellite tracking expertise", "We work to proven standards, with certified hardware and the reliable Wialon platform."],
            ["Only proven hardware", "Teltonika, Omnicomm and Escort — with real warranties and kept in stock."],
            ["Wialon Local — the world's No. 1 software", "Over 3,500,000 connected units, 42% CIS market share, used in 132 countries."],
            ["Local field team", "Installation, diagnostics and repairs without waiting for specialists from Tashkent — based in Nukus, covering Karakalpakstan and Khorezm."],
            ["Training and support", "Professional advice and technical support with no limits on time or number of requests."],
            ["End-to-end service", "From defining the task and choosing a solution to installation, launch and ongoing support."],
        ],

        contact: {
            eyebrow: "Contact ALL SYSTEMS",
            title: "Request a test installation for your fleet",
            text: "For fleets of 20+ vehicles, we fit several of them with a test unit free of charge.",
            company: "Company name",
            companyPh: "Example LLC",
            name: "Your name*",
            namePh: "First and last name",
            phone: "Phone*",
            email: "Email",
            service: "Service",
            services: { gps: "GPS tracking", cameras: "Surveillance cameras" },
            vehicles: "Number of vehicles",
            vehiclesPh: "e.g. 12",
            install: "Installation type",
            installs: { car: "Vehicle", object: "Building / site" },
            message: "Message",
            messagePh: "Tell us about your fleet (or site) and what you need",
            send: "Send request",
            sending: "Sending...",
            consent: "By sending this form, you agree to ALL SYSTEMS processing your contact details.",
            successTitle: "Request received",
            successText: "An ALL SYSTEMS manager will contact you during business hours.",
            again: "Send another",
            error: "Couldn't send your request. Please try again or call us:",
            phoneTitle: "Phone",
            emailTitle: "Email",
            address: "Address",
            addressValue: "Nukus, Uzbekistan",
            hours: "Working hours",
            days: [["Mon–Fri", "09:00–18:00"], ["Sat", "09:00–12:30"], ["Lunch", "12:30–14:30"]],
            sunday: "Sun",
            dayOff: "Closed",
        },

        footer: {
            about: "GPS vehicle tracking, fuel monitoring and video surveillance. Based in Nukus, serving Karakalpakstan and Khorezm.",
            company: "Company",
            services: "Services",
            contacts: "Contact",
            why: "Why us",
            coverage: "Coverage",
            popular: "Popular services",
            copy: "ALL SYSTEMS LLC. Satellite vehicle tracking and video surveillance.",
        },
    },
};

export default T;
